import React, { useRef, useState } from 'react'
import { EventExpansionPanelSummary } from 'Event/components/EventExpansionPanelSummary'
import { EventExpansionPanelDetails } from 'Event/components/EventExpansionPanelDetails'
import { EventExpansionPanel } from 'Event/components/EventExpansionPanel'
import { OpportunityResponseWithRecurrenceInfo } from 'Event/interfaces/interfaceCreateEditEvent'
import { useExpansionPanelSummaryStyle } from 'Event/hooks/useExpansionPanelSummaryStyle'
import { ActivityLog } from 'tracking/activity/components/ActivityLog'
import { useHistory } from 'react-router'
import { Opportunity } from '../interfaces'

export const OpportunityDrilldownActivities = ({
  event,
  scrollTop,
}: {
  event: OpportunityResponseWithRecurrenceInfo
  scrollTop: number
}) => {
  const [expanded, setExpanded] = useState(true)
  const summaryRef = useRef<HTMLDivElement>(null)
  const detailsRef = useRef<HTMLDivElement>(null)

  const style = useExpansionPanelSummaryStyle({
    expanded,
    scrollTop,
    summaryRef,
    detailsRef,
  })

  const history = useHistory()

  return (
    <>
      <EventExpansionPanel onChange={(_, expanded) => setExpanded(expanded)}>
        <EventExpansionPanelSummary name="opportunity-activities" style={style} ref={summaryRef}>
          <h1>Activity Log</h1>
        </EventExpansionPanelSummary>
        <EventExpansionPanelDetails ref={detailsRef}>
          <ActivityLog
            opportunity={{ id: event.opportunityId, name: event.name } as Opportunity}
            tableName="opportunityActivityLog"
          />
        </EventExpansionPanelDetails>
      </EventExpansionPanel>
    </>
  )
}
